import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconContributor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_644_19746)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 2C5.105 2 6 2.895 6 4C6 5.105 5.105 6 4 6C2.895 6 2 5.105 2 4C2 2.895 2.895 2 4 2ZM0 10V9C0 7.67 2.665 7 4 7C5.335 7 8 7.67 8 9V10H0Z",
			fill: "#026BB6"
		}), /* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip1_644_19746)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6.75 5.31312V6.25063H7.6875L10.4525 3.48562L9.515 2.54813L6.75 5.31312ZM11.1775 2.76063C11.275 2.66313 11.275 2.50563 11.1775 2.40813L10.5925 1.82312C10.495 1.72563 10.3375 1.72563 10.24 1.82312L9.7825 2.28062L10.72 3.21812L11.1775 2.76063Z",
				fill: "#0068B4"
			})
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_644_19746",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_644_19746",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 6,
			height: 6,
			fill: "white",
			transform: "translate(6 1)"
		})
	})] })]
});
export default SvgIconContributor;
